import React 						from 'react';
import ReactDOM 					from 'react-dom';
import { Provider } 				from 'react-redux'
import configureStore, { history } 	from './store/configureStore'
import RootContainer 				from './components/containers/RootContainer';
import { ConnectedRouter } 			from 'react-router-redux'
import registerServiceWorker 		from './registerServiceWorker';
import './static/css/normalize.css';
import 'react-sortable-tree/style.css';
import './static/css/styles.css';

export const store = configureStore()

ReactDOM.render((
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <RootContainer/>
        </ConnectedRouter>
    </Provider>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js